import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "modal-content w-100 bg-transparent" }
const _hoisted_2 = {
  key: 0,
  class: "modal-header"
}
const _hoisted_3 = { class: "modal-title" }
const _hoisted_4 = {
  key: 0,
  style: {"font-size":"var(--font-sm)","font-weight":"400","letter-spacing":"-3%"}
}

import { onMounted, ref, watch } from "vue";
import { Modal } from "bootstrap";

import { Button } from "@/components/global";
import { CircleCloseIcon } from "@/components/svg";


export default /*@__PURE__*/_defineComponent({
  __name: 'Modal',
  props: {
    showModal: { type: Boolean },
    closable: { type: Boolean },
    rounded: { type: Boolean },
    maxWidth: {},
    header: {},
    closeType: {}
  },
  emits: ["closeModal"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const showModalRef = ref<HTMLElement | null>(null);
const modalInstance = ref<Modal | null>(null);

watch(() => props.showModal, value => {
  if (modalInstance.value) {
    value ? modalInstance.value.show() : modalInstance.value.hide();
  }
});

onMounted(() => {
  if (showModalRef.value) {
    modalInstance.value = new Modal(showModalRef.value);

    showModalRef.value.addEventListener("hidden.bs.modal", () => {
      emit("closeModal");
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade p-0",
    ref_key: "showModalRef",
    ref: showModalRef,
    "data-bs-backdrop": "static",
    "data-bs-keyboard": "false",
    tabindex: "-1",
    "aria-labelledby": "staticBackdropLabel",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", {
      class: "modal-dialog modal-dialog-centered",
      style: _normalizeStyle({ maxWidth: __props.maxWidth })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "position-relative w-100",
          style: _normalizeStyle({ background: 'var(--ch-white)', borderRadius: __props.rounded ? '10px': 0 })
        }, [
          (__props.header)
            ? (_openBlock(), _createElementBlock("header", _hoisted_2, [
                _createElementVNode("h2", _hoisted_3, _toDisplayString(__props.header), 1)
              ]))
            : _createCommentVNode("", true),
          (__props.closable)
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 1,
                variant: "naked",
                class: "close-btn",
                style: _normalizeStyle({
              color: 'var(--ch-black)',
              width: __props.closeType === 'text' ? 'auto' : '1.5rem',
              height: __props.closeType === 'text' ? 'auto' : '1.5rem'
            }),
                "aria-label": "close-modal-btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('closeModal'))),
                testId: "close-modal-btn"
              }, {
                default: _withCtx(() => [
                  (__props.closeType === 'text')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, " Close "))
                    : (_openBlock(), _createBlock(_unref(CircleCloseIcon), { key: 1 }))
                ]),
                _: 1
              }, 8, ["style"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "modal-body",
            style: _normalizeStyle({ padding: __props.header ? '1rem 0 0 0' : 0 })
          }, [
            _renderSlot(_ctx.$slots, "default")
          ], 4)
        ], 4)
      ])
    ], 4)
  ], 512))
}
}

})